/* Instruments */

import { ReduxState } from '~/store';

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectForm = (state: ReduxState) => state.form.formData;
export const selectIsSubmitLoading = (state: ReduxState) => state.form.isSubmitLoading;
export const selectIsDownloadLoading = (state: ReduxState) => state.form.isDownloadLoading;
export const selectInvoiceId = (state: ReduxState) => state.form.invoiceId;
export const selectBusinessUuid = (state: ReduxState) => state.user.businessDetails.business_uuid;
export const selectIsSidebarOpen = (state: ReduxState) => state.user.isSidebarOpen;
export const selectUser = (state: ReduxState) => state.user;
